interface PagedRequest {
  page?: number
  page_size?: number
  [key: string]: any
}

export interface PagedResponse<T> {
  count: number
  next?: string
  previous?: string
  currentPage: number
  pageSize?: number
  totalPages: number
  results: T[]
}

export function transformPagination<T>(
  req: PagedRequest,
  res: { count: number; results: any[] },
): PagedResponse<T> {
  const pageSize = req.page_size || 10
  return {
    ...res,
    currentPage: req.page || 1,
    pageSize: req.page_size,
    totalPages: Math.ceil(res.count / pageSize),
  }
}
